var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"mr-1 w-4 h-4",attrs:{"fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","viewBox":"0 0 24 24","stroke":"currentColor"}},[_c('path',{attrs:{"d":"M15 19l-7-7 7-7"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }